/**
 * Created by piotr.pozniak@thebeaverhead.com on 23/07/2025
 */
import { hasSubscription } from "../../helpers/organization";
import { useCurrentOrganizationStore } from "../../../../hooks/redux/currentOrganization";
import {
  QuotaLabelMapping,
  QUOTAS,
  UsageFieldsMapping,
} from "../../../../consts";

const QuotaSubheader = ({ quotaItem }) => {
  const { currentOrganization } = useCurrentOrganizationStore();
  const subscription = hasSubscription(currentOrganization);

  const usage = Number(
    currentOrganization.model.usage[UsageFieldsMapping[quotaItem]] || 0
  );

  if (!subscription || !subscription.quotas) {
    return null;
  }

  const quotaValue = Number(subscription.quotas[quotaItem]);

  if (quotaValue === undefined) {
    return null;
  }

  let summary = "";

  if (quotaValue === -1) {
    summary = `Your plan includes unlimited ${QuotaLabelMapping[quotaItem]}s.`;
  } else if (quotaValue === 0) {
    summary = `Your plan does not include any ${QuotaLabelMapping[quotaItem]}s.`;
  } else {
    summary = `You have used ${usage} of ${quotaValue} ${
      QuotaLabelMapping[quotaItem]
    }${quotaValue > 1 ? "s" : ""}.`;
  }

  return (
    <h6 className={"m-t-5 d-flex align-items-center gap-xs"}>
      <div>{summary}</div>
    </h6>
  );
};

export default QuotaSubheader;
